import axios from "axios";
import appConfig from "configs/app.config";
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from "constants/api.constant";
import { PERSIST_STORE_NAME } from "constants/app.constant";
import deepParseJson from "utils/deepParseJson";
import store from "../store";
import { onSignOutSuccess } from "../store/auth/sessionSlice";
import { userLoggedOut } from "store/auth/userSlice";
import { Environment, getEnvironment } from "utils/getEnvironment";

const unauthorizedCode = [401, 400];

const BaseService = axios.create({
  // timeout: 60000,
  baseURL: getEnvironment(Environment.DEVELOPMENT)
    ? appConfig.apiStaging
    : appConfig.apiPrefix,
});


BaseService.interceptors.request.use(
  (config) => {
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);

    const accessToken = persistData.auth.session.token;

    if (accessToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    // console.log('res interceptor err', response);
    

    if (
      response &&
      unauthorizedCode.includes(response.status) &&
      ["Unauthorized", "Token is blacklisted"].includes(
        response?.data?.detail
      )
    ) {
      store.dispatch(onSignOutSuccess());
    }

    if (
      response &&
      unauthorizedCode.includes(response.status) &&
      ["user_inactive"].includes(response?.data?.code)
    ) {
      store.dispatch(onSignOutSuccess());
      store.dispatch(userLoggedOut());
    }

    return Promise.reject(error);
  }
);

export default BaseService;
